{
  "home": {
    "title": "Domov",
    "menu": {
      "sidebar": {
        "label": "Domov"
      },
      "tabBar": {
        "label": "Domov"
      }
    }
  },
  "chat": {
    "title": "Chat",
    "menu": {
      "sidebar": {
        "label": "Chat"
      },
      "tabBar": {
        "label": "Chat"
      }
    }
  },
  "workouts": {
    "title": "Tréningy",
    "menu": {
      "sidebar": {
        "label": "Tréningy"
      },
      "tabBar": {
        "label": "Tréningy"
      }
    }
  },
  "meals": {
    "title": "Jedlá",
    "menu": {
      "sidebar": {
        "label": "Jedlá"
      },
      "tabBar": {
        "label": "Jedlá"
      }
    }
  },
  "profile": {
    "title": "Profil",
    "menu": {
      "sidebar": {
        "label": "Profil"
      },
      "tabBar": {
        "label": "Profil"
      }
    }
  },
  "logout": "Odhlásiť sa",
  "menu": "Ponuka",
  "userMenu": {
    "title": "Ponuka",
    "settings": "Nastavenia",
    "billing": "Predplatné"
  }
}
